import type { MutableState } from '../State';
import { Dialog, splitDialogId } from './conservation.ruleset';

export function incrementTimesSeen(
  state: MutableState,
  dialogId: Dialog['id'],
): void {
  const [species, key] = splitDialogId(dialogId);
  const counts = (state.conversation.dialogCounts[species] ??= {});
  counts[key] = (counts[key] ?? 0) + 1;
}

export function saveAnswer(
  state: MutableState,
  answer: { answerVar: string; key?: string; value: string },
): void {
  const { answerVar, ...answerProps } = answer;
  state.conversation.answers[answerVar] = answerProps;
}
